import Button from 'components/form-elements/Button';
import ButtonCol from 'components/form-elements/ButtonCol';
import Col from 'components/ui-elements/Col';
import { LangLabel } from 'data/LangLabel';
import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { Fragment, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Card from 'components/ui-elements/Card';
import Row from 'components/ui-elements/Row';
import useMsgBox from 'hooks/useMsgBox';
import ItemInput from './ItemInput';


const MyFormEditable = (props) => {
    const { url, onSuccess, onError, onCancel, onChangeForm, coltype, cellid, editid, columns, title,
        lblcancel = LangLabel.LABEL_CANCEL, lblsave = LangLabel.LABEL_SAVE, defaultValue,
        saveColSize = 2, cancelColSize = 2,
        saveHandle = null,
        confirmSubmitTitle = "Konfirmasi",
        confirmSubmitMessage = "",
        hideFooter = false,
        renderFooter = null,
        children,
        wrapInForm = true,
        ...rest } = props

    const [showMsg, confirmMsg] = useMsgBox();
    const [resp, error, loading, axiosFetch] = useAxiosFunction();
    const { setValue, register, handleSubmit, watch, control, formState: { errors } } = useForm();
    const alldata = watch()
    const appliedDefaultRef = useRef(null)

    useEffect(() => {
        if (!defaultValue) return
        const defaultKey = JSON.stringify(defaultValue)
        if (appliedDefaultRef.current === defaultKey) return
        appliedDefaultRef.current = defaultKey
        if (Object.keys(defaultValue).length > 0) {
            const keys = Object.keys(defaultValue)
            keys.forEach((key) => {
                setValue(key, defaultValue[key])
            })
        }
    }, [defaultValue, setValue])

    useEffect(() => {
        onChangeForm(setValue, alldata)
    }, [JSON.stringify(alldata)])

    const onSubmit = async (reqdata) => {
        if (confirmSubmitMessage) {
            const ok = await confirmMsg(confirmSubmitTitle, confirmSubmitMessage)
            if (!ok) return
        }
        const idforupdate = editid ? editid : cellid
        let hasil = null

        if (typeof saveHandle === 'function') {
            hasil = await saveHandle(reqdata, defaultValue)
        } else {
            let urlsave = url
            if (Object.keys(defaultValue).length > 0 && reqdata?.[idforupdate]) {
                urlsave = url + "/" + reqdata[idforupdate]
            }
            hasil = await axiosFetch({
                method: 'POST',
                url: urlsave,
                data: reqdata,
                auth: true
            })
        }

        if (hasil?.data?.success === true) {
            await showMsg("Informasi", "Data berhasil disimpan.")
            onSuccess(hasil, reqdata)
        } else if (hasil?.data?.success === false) {
            await showMsg("Error", hasil?.message)
            onError(hasil?.message)
        } else {
            await showMsg("Error", "Tidak terhubung ke server!")
            onError("Tidak terhubung ke server!")
        }
    }

    const content = (
        <>
            <Card title={title}>
                <Row>
                    {columns && columns.map((elname, idx) => {
                        const element = coltype?.[elname]
                        return <ItemInput
                            elname={elname}
                            {...element}
                            setValue={setValue}
                            register={register}
                            handleSubmit={handleSubmit}
                            watch={watch}
                            errors={errors}
                            control={control}
                            key={"input-item" + idx}
                            idx={idx}
                            editid={editid ? editid : cellid}
                            defaultValue={defaultValue}
                            coltype={coltype}
                        />
                    })}
                </Row>
            </Card>

            {children}

            {!hideFooter && columns && coltype && typeof renderFooter !== 'function' &&
                <Card className="mb-0">
                    <Row>
                        <ButtonCol colsize={saveColSize} loading={loading} type="submit" title={lblsave} block={true} />
                        <Col size={cancelColSize}>
                            <Button onClick={() => onCancel()} title={lblcancel} block={true} />
                        </Col>
                    </Row>
                </Card>
            }

            {!hideFooter && columns && coltype && typeof renderFooter === 'function' ? renderFooter({
                loading,
                onCancel,
                submitProps: {
                    onClick: handleSubmit(onSubmit),
                    type: "button",
                }
            }) : null}
        </>
    )

    if (!wrapInForm) return content

    return <form onSubmit={handleSubmit(onSubmit)}>{content}</form>
}

MyFormEditable.defaultProps = {
    onSuccess: () => { },
    onError: () => { },
    onCancel: () => { },
    onChangeForm: (setVal, data) => { },
    defaultValue: {},
    saveColSize: 2,
    cancelColSize: 2,
    saveHandle: null,
    hideFooter: false,
    renderFooter: null,
    wrapInForm: true,
}

export default MyFormEditable
